var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.27 21.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.26,3.8c-.69,0-1.25,.56-1.25,1.25s.56,1.25,1.25,1.25,1.25-.56,1.25-1.25-.56-1.25-1.25-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.72,5.4c-2.89,0-5.24,2.35-5.24,5.24s2.35,5.24,5.24,5.24,5.24-2.35,5.24-5.24-2.35-5.24-5.24-5.24Zm0,8.59c-1.85,0-3.35-1.5-3.35-3.35s1.5-3.35,3.35-3.35,3.35,1.5,3.35,3.35-1.5,3.35-3.35,3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.88,21.27H6.39c-3.52,0-6.39-2.87-6.39-6.39V6.39C0,2.87,2.87,0,6.39,0H14.88c3.52,0,6.39,2.87,6.39,6.39V14.88c0,3.52-2.87,6.39-6.39,6.39ZM6.39,2c-2.42,0-4.39,1.97-4.39,4.39V14.88c0,2.42,1.97,4.39,4.39,4.39H14.88c2.42,0,4.39-1.97,4.39-4.39V6.39c0-2.42-1.97-4.39-4.39-4.39H6.39Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB3);
export default __webpack_public_path__ + "static/media/b3.78259a8de4973c42dae63f1dc839ae28.svg";
export { ForwardRef as ReactComponent };